import { render } from "./Substitutions.vue?vue&type=template&id=23745743&scoped=true&ts=true"
import script from "./Substitutions.vue?vue&type=script&lang=ts"
export * from "./Substitutions.vue?vue&type=script&lang=ts"

import "./Substitutions.vue?vue&type=style&index=0&id=23745743&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23745743"]])

export default __exports__